import React from "react";
import NotificationSystem from "react-notification-system";
import PropTypes from "prop-types";
import Form from "react-jsonschema-form";
import $ from "jquery";
import {
  buscarGRUAtiva,
  enviarSubmissaoGRU,
  apagarSubmissaoGRU,
  buscaCEP,
  consultaCEP,
  buscarCustoBoleto
} from "../../../view/gru/actions/GRUActions";
import { downloadFileLink } from "../../../helpers/Downloads";
import { View, Progress, Label } from "react-template";

class GRUContainer extends View {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.formularioExiste = false;
    this.formSubmissao = null;
    this.idSubmissao = null;
    this.indicadorPessoa = 1;
    this.statusLoader = false;
    this.state = {
      permissao: "",
      schema: {},
      uiSchema: {},
      formData: {},
      formEditavel: {},
      certificado: false,
      valorInscricao: 0,
      limiteDeInscritos: 0,
      cidade: "",
      uf: ""
    };
    this.liveValidate = false;
    this.cepPreenchido = false;
  }

  setPermissaoCamposIniciais() {
    const tipoCampoIdentificadorGRU = this.state.formEditavel.itens[0].tipo;
    $(function () {
      // Desabilitando inputs
      $(
        ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
      ).prop("disabled", true);
      $(
        ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
      ).addClass("disable");
      if (tipoCampoIdentificadorGRU === "textocurto-cpf") {
        $("input[id=root_questao_0]").attr("disabled", false);
        $("input[id=root_questao_0]").removeClass("disable");
        $("input[id=root_questao_0]").focus();
      } else {
        $("input[id=root_questao_0").attr("disabled", false);
        $("input[id=root_questao_0").removeClass("disable");
        $("input[id=root_questao_0").focus();
      }
    });
  }

  liberarCamposFormulario() {
    $(function () {
      $(
        ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
      ).prop("disabled", false);
      $(
        ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
      ).removeClass("disable");
    });
  }

  liberarCamposEndereco(liberaCampos) {
    $(function () {
      for (let i = 5; i <= 8; i = i + 3) {
        const $input = $(`input[id=root_questao_${i}]`);
        $input.prop("disabled", !liberaCampos);
        liberaCampos
          ? $input.removeClass("disable")
          : $input.addClass("disable");
      }
    });
  }

  limparCamposEndereco() {
    $(function () {
      for (let i = 5; i <= 8; i = i + 3) {
        $(`input[id=root_questao_${i}]`).val("");
      }
    });
  }

  changeSubmitStatus(bool) {
    $(function () {
      $(
        ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
      ).prop("disabled", bool);
      if (bool) {
        $(
          ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
        ).addClass("disable");
      } else {
        $(
          ".form-builder-layout input, .form-builder-layout select, .form-builder-layout textarea, .form-builder-layout button[type=submit]"
        ).removeClass("disable");
      }
    });
  }

  componentDidMount() {
    if (this.props.idForm === undefined) {
      this.setState({
        schema: this.props.schema,
        uiSchema: this.props.uiSchema
      });
      this.formularioExiste = true;
      this.forceUpdate();
    } else {
      buscarGRUAtiva(
        this.props.idForm,
        res => {
          let formEditavel = res.data.formEditavel;
          let formEditavel_json = JSON.parse(formEditavel);
          let form = res.data.formSchema;
          let form_json = JSON.parse(form);

          this.setState({
            ...this.state,
            schema: form_json.schema,
            uiSchema: form_json.uiSchema,
            formEditavel: formEditavel_json
          });

          if (res.data.status) {
            //GRU disponível
            this.formularioExiste = true;
            this.forceUpdate();
          } else {
            this.formularioExiste = null;
            this.setState({ schema: null, uiSchema: null });
          }

          this.setPermissaoCamposIniciais();
        },
        error => {
          this.notifyError("Erro ao buscar GRU", "");
          this.formularioExiste = null;
          this.setState({ schema: null, uiSchema: null });
        }
      );
      buscarCustoBoleto(res => {
        this.setState({
          ...this.state,
          custo_boleto: res.data
        });
      },
        error => {
          this.notifyError("Erro ao buscar custo do Boleto", "");
        })
    }
  }

  // validador de CPF
  TestaCPF(cpf) {
    const strCPF = cpf.replace(/[.-]/g, "");
    let Soma;
    let Resto;
    Soma = 0;
    if (
      strCPF === "00000000000" ||
      strCPF === "11111111111" ||
      strCPF === "22222222222" ||
      strCPF === "33333333333" ||
      strCPF === "44444444444" ||
      strCPF === "55555555555" ||
      strCPF === "66666666666" ||
      strCPF === "77777777777" ||
      strCPF === "88888888888" ||
      strCPF === "99999999999"
    )
      return false;

    for (var i = 1; i <= 9; i++) {
      Soma += parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
    }

    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10), 10)) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++)
      Soma += parseInt(strCPF.substring(i - 1, i), 10) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11), 10)) return false;
    return true;
  }

  testaCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");
    this.indicadorPessoa = 2;
    if (cnpj === "") return false;
    if (cnpj.length !== 14) return false;
    // Elimina CNPJs invalidos conhecidos
    if (
      cnpj === "00000000000000" ||
      cnpj === "11111111111111" ||
      cnpj === "22222222222222" ||
      cnpj === "33333333333333" ||
      cnpj === "44444444444444" ||
      cnpj === "55555555555555" ||
      cnpj === "66666666666666" ||
      cnpj === "77777777777777" ||
      cnpj === "88888888888888" ||
      cnpj === "99999999999999"
    )
      return false;
    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado + "" !== digitos.charAt(0)) return false;
    tamanho += 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    let i;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado + "" !== digitos.charAt(1)) return false;

    return true;
  }

  onChange(form) {
    if (this.props.idForm !== undefined) {
      if (form.errors.length > 0) {
        this.liveValidate = true;
      }
      const tipoCampoIdentificadorGRU = this.state.formEditavel.itens[0].tipo;
      let validLength =
        tipoCampoIdentificadorGRU === "textocurto-cpf" ? 14 : 18;
      let funcaoTestaCampoIdentificadorGRU =
        tipoCampoIdentificadorGRU === "textocurto-cpf"
          ? this.TestaCPF.bind(this)
          : this.testaCNPJ.bind(this);

      //Campo CPF / CNPJ
      this.onChangeCampoCpfCnpj(
        form,
        validLength,
        funcaoTestaCampoIdentificadorGRU
      );

      //Campo CEP
      this.onChangeCep(form);
    }
  }

  onChangeCampoCpfCnpj(form, validLength, funcaoTestaCampoIdentificadorGRU) {
    if (
      form.formData.questao_0 !== undefined &&
      form.formData.questao_0.length === validLength
    ) {
      if (funcaoTestaCampoIdentificadorGRU(form.formData.questao_0)) {
        this.liberarCamposFormulario();
        this.setState({ ...this.state, formData: form.formData });
      } else {
        this.notifyWarning(
          (validLength === 14 ? "CPF" : "CNPJ") + " Inválido!",
          ""
        );
        this.setPermissaoCamposIniciais();
      }
    } else {
      // setando campos iniciais novamente
      this.setPermissaoCamposIniciais();
    }
  }

  onChangeCep(form) {
    let cep = form.formData.questao_4;
    if (cep !== undefined && cep.length === 9) {
      if (!this.cepPreenchido) {
        this.changeLoaderStatus();
        return consultaCEP(
          cep,
          endereco => {
            if (endereco) {
              this.setState({ uf: endereco.uf, cidade: endereco.cidade });
              this.preencheValoresEndereco(endereco, form);
              this.cepPreenchido = true;
              this.liberarCamposEndereco(true);
            } else {
              this.liberarCamposEndereco(false);
              this.notifyWarning("Não foi possível buscar o CEP informado");
            }
          },
          error => {
            buscaCEP(cep, res => {
              if (res) {
                let endereco = {};
                endereco["cep"] = res.data.cep;
                endereco["logradouro"] = res.data.logradouro;
                endereco["complemento"] = res.data.complemento;
                endereco["bairro"] = res.data.bairro;
                endereco["numero"] = form.formData.questao_7;
                this.setState({ uf: res.data.uf, cidade: res.data.localidade });
                this.preencheValoresEndereco(endereco, form);
                this.cepPreenchido = true;
                this.liberarCamposEndereco(true);
              } else {
                this.liberarCamposEndereco(false);
                this.notifyWarning("Não foi possível buscar o CEP informado");
              }

            }, error => {
              this.notifyWarning("Não foi possivel consultar os serviços de confirmação de CEP, tente novamente mais tarde");
            })

          }).finally(() => this.changeLoaderStatus());
      }
    } else {
      this.cepPreenchido = false;
      this.liberarCamposEndereco(false);

      if (!cep) {
        this.limparCamposEndereco();
      }
    }
  }

  preencheValoresEndereco(endereco, form) {
    $(function () {
      const $logradouro = $("input[id=root_questao_5]");
      $logradouro.val(endereco["logradouro"]);
      $logradouro.attr("value", endereco["logradouro"]);
      form.formData.questao_5 = endereco["logradouro"];

      const $complemento = $("input[id=root_questao_6]");
      $complemento.val(endereco.complemento);
      $complemento.attr("value", endereco.complemento);
      form.formData.questao_6 = endereco.complemento;

      $("input[id=root_questao_7]").val(endereco.numero);
      $("input[id=root_questao_7]").attr("value", endereco.numero);
      form.formData.questao_7 = endereco.numero;

      const $bairro = $("input[id=root_questao_8]");
      $bairro.val(endereco.bairro);
      $bairro.attr("value", endereco.bairro);
      form.formData.questao_8 = endereco.bairro;
    });
  }

  onSubmit(form) {
    this.submeter(form);
  }

  submeter(form) {
    if (this.props.idForm !== undefined) {
      this.changeSubmitStatus(true);
      this.changeLoaderStatus();
      let { idForm, data } = this.carregaDadosSubmissao(form);
      enviarSubmissaoGRU(
        idForm,
        data,
        res => {
          downloadFileLink(res.data, "boleto-" + form.formData.questao_0);
          this.changeLoaderStatus();
          this.notifySucess("GRU criada com sucesso!", "");
        },
        error => {
          this.changeLoaderStatus();
          this.changeSubmitStatus(false);
          this.notifyError("Erro ao gerar GRU", "");
        }
      );
    }
  }

  onSucessDownloadBoleto() {
    this.changeLoaderStatus();
    this.notifySucess("GRU criada com sucesso!", "");
  }

  onErrorDownloadBoleto(id) {
    apagarSubmissaoGRU(id, res => { }, error => { });
    this.changeLoaderStatus();
    this.changeSubmitStatus(false);
    this.notifyError("Erro ao gerar GRU", "");
  }

  getValorBoleto = () => {
    let questao = document.getElementById("root_questao_2");
    if (!questao) {
      return '0,00'
    }
    let valor = questao.value;
    
    if (valor.length < 3) {
      valor = `${valor},00`;
    }

    // valor = valor.replace(/\./g, '');
    // valor = valor.replace(',', '.');

    return valor;
  };

  getValorTotalDoBoleto = () => {
    let valor  = this.getValorBoleto();
    let custo = this.state.custo_boleto;
    return parseFloat(valor.replace(',','.'))+ parseFloat(custo);
  }

  carregaDadosSubmissao(form) {
    const idForm = this.props.idForm;
    const cpfCnpj = form.formData.questao_0;
    const nome = form.formData.questao_1;
    form.formData.questao_2 = this.getValorBoleto();
    let valor = form.formData.questao_2;

    const dataVencimento = form.formData.questao_3;
    let formData = form.formData;
    let dadosForm = JSON.stringify(formData);
    let enderecoSacado = {
      cep: form.formData.questao_4,
      logradouro: form.formData.questao_5,
      complemento: form.formData.questao_6,
      numero: form.formData.questao_7,
      bairro: form.formData.questao_8,
      cidade: this.state.cidade,
      uf: this.state.uf
    };
    const data = {
      cpfCnpj: cpfCnpj,
      nome: nome,
      valor: valor,
      dataVencimento: dataVencimento,
      dadosForm: dadosForm,
      enderecoSacado: enderecoSacado,
      indicadorPessoa: this.indicadorPessoa
    };
    return { idForm, cpfCnpj, data };
  }

  transformErrors(errors) {
    // Mudando titulo do panel de erro
    $(function () {
      $(".form-builder-layout .errors h3").text("Ops! Erros encontrados.");
    });

    const errorMessengerList = {
      required: `Campo obrigatório precisa ser preenchido: `,
      email: "Campo de E-mail com informação invalida",
      date: "Data Inválida",
      number: "Formato de número invalido."
    };

    return errors.map(error => {
      if (error.name === "required") {
        error.message =
          errorMessengerList.required +
          error.schema.properties[error.argument].title;
        error.stack =
          errorMessengerList.required +
          error.schema.properties[error.argument].title;
      } else if (error.name === "format" && error.argument === "email") {
        error.message = errorMessengerList.email;
        error.stack = errorMessengerList.email + ": " + error.schema.title;
      } else if (error.name === "format" && error.argument === "date") {
        error.message = errorMessengerList.date;
        error.stack = errorMessengerList.date + ": " + error.schema.title;
      } else if (error.name === "type" && error.schema.type === "number") {
        error.message = errorMessengerList.number;
        error.stack = errorMessengerList.number + ": " + error.schema.title;
      }
      return error;
    });
  }

  temResubmissao() {
    return (
      this.props.idForm !== undefined && !this.state.formEditavel.resubmissao
    );
  }

  changeLoaderStatus() {
    this.statusLoader = !this.statusLoader;
    this.forceUpdate();
  }

  render() {
    return (
      <div>
        <NotificationSystem ref={n => (this.notificationSystem = n)} />
        <div className="box form-builder-layout p-r form-answer">
          {this.formularioExiste ? (
            <div>
              {this.statusLoader && <Progress position={"bottom"} />}
              <div className="form-info">
                <section>{this.state.schema.title}</section>
                <Label basic color='green' title='Taxa de Inscrição' size=".85">
                  valor: R$ {this.getValorTotalDoBoleto()}
                </Label>
                <p>{this.state.schema.description}</p>
              </div>
              <Form
                schema={this.state.schema}
                uiSchema={this.state.uiSchema}
                onSubmit={this.onSubmit}
                onChange={this.onChange}
                formData={this.state.formData}
                transformErrors={this.transformErrors}
                showErrorList={false}
                liveValidate={this.liveValidate}
              >
                <div>
                  <button className="btn btn-primary" type="submit">
                    Enviar
                  </button>
                </div>
              </Form>
            </div>
          ) : (
              this.formularioExiste === null && (
                <div>
                  <h1>A GRU não está disponível ou não existe</h1>
                </div>
              )
            )}
        </div>
      </div>
    );
  }
}

GRUContainer.propTypes = {
  idForm: PropTypes.string,
  schema: PropTypes.object,
  uiSchema: PropTypes.object
};

export default GRUContainer;



// WEBPACK FOOTER //
// ./src/components/formbuilder/container/GRUContainer.js